import React, { useState, useEffect, useContext } from 'react';
import axios from "axios"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faCopy, faEye, faFileDownload} from '@fortawesome/free-solid-svg-icons'
import { ProfileContext, CompareContext } from '../App';
import logo from "../logo.png"



function ProfileListComponent(props) {
    // props.stateFunctions is a prop being passed down from the parent component, HomeComponent.
    // That state functions and its state variables were instantiated in the HomeComponent
    // but we needed the functionality from the setTabIndex function and others to be used here as well.

    // What the stateFunctions variable looks like
    // stateFunctions = [setTabIndex, setCompareProfileName, setCompareFlowRate, setCompareHv, setCompareLv, setCompareDutyCycle, setCompareFrequency, handleTwoProfilesToCompare, twoProfilesToCompare, setTwoProfilesToCompare, setSingleProfileView, setSingleProfile]

    const profileContext = useContext(ProfileContext)
    const compareContext = useContext(CompareContext)
    // items at their indicies 
    //  profileContext = [
    //     0 => profileName,
    //     1 => flowRate,
    //     2 => hv,
    //     3 => lv,
    //     4 => dutyCycle,
    //     5 => frequency
    // ]

    const fetchProfiles = async (payload) => {
        const token = localStorage.getItem("token")
        const response = await axios.post("http://18.234.199.102:5000/profiles", payload, {headers:{
            'Access-Control-Allow-Origin' : '*',
            "Authorization": `Bearer ${token}`
        }})
        if (response.data) {
            let profileData = []
            for (let key in response.data) {
                let profile = [
                    response.data[key].profile_id,
                    response.data[key].profile_name,
                    response.data[key].flow_rate,
                    response.data[key].hv,
                    response.data[key].lv,
                    response.data[key].duty_cycle,
                    response.data[key].frequency,  
                ]
                profileData.push(profile)
            }
            setProfiles(profileData)
            return profileData
        }
    }

    const [profiles, setProfiles] = useState([])
    const [profileName, setProfileName] = useState(profileContext[0])
    const [flowRate, setFlowRate] = useState(profileContext[1])
    const [hv, setHv] = useState(profileContext[2])
    const [lv, setLv] = useState(profileContext[3])
    const [dutyCycle, setDutyCycle] = useState(profileContext[4])
    const [frequency, setFrequency] = useState(profileContext[5])
    const [profileId, setProfileId] = useState("")
    const [selectedForCompare, setSelectedForCompare] = useState("")

    const cloneProfile = async (profile) => {
        /* In this function, we are doing two things. The first is setting the context
        of compareContext to be the value of the currently selected profile. This allows
        our line graph to display the comparision data.
        
        The second thing we are doing is similar in nature. We are keying into the props
        passed into this component by the parent component (HomeComponent). The props have the value
        of an array and the array contains helper functions that change the state of certain variables
        in the parent component.
        
        We need to do this step because changing the state of compareFlowRate, compareHv, etc. in the
        parent function forces our component to re-mount. This translates to the user being able to click on the
        compare button and see their change in the line graph in real time*/

        // This allows the user to click on the profile in their list, and then change the profileContext of the app to match the clicked profile
        // The profileContext is tracked by the WaveGraphComponent so the idea is that the user will see the visual representation update to match
        // that profile on click, as well as those same values listed on the sliders in the CreateProfile component.

        // stateFunctions[9] is the state variable for singleProfileView and stateFunctions[10] is the state function for setSingleProfileView
        if (props.stateFunctions[10] === true) {
            props.stateFunctions[11](false)
        }
        // stateFunctions[8] is the state variable for twoProfilesToCompare
        if (props.stateFunctions[8].length === 2) {
            let compareProfile = props.stateFunctions[8][1]
            // stateFunctions[9] is the function to change the state of twoProfilesToCompare
            props.stateFunctions[9]([profile[1], compareProfile])
        } else if (props.stateFunctions[8].length === 1) {
            let newCompareProfile = props.stateFunctions[8][0]
            // change compare context to what profileContext currently is
            handleCompareContextHelper()
            props.stateFunctions[9]([profile[1], newCompareProfile])
        } else {
            props.stateFunctions[9]([profile[1]])
        }

        setProfileId(profile[0]) // profileId

        profileContext[0] = profile[1] // profileName
        setProfileName(profileContext[0])

        profileContext[1] = profile[2] // flowRate
        setFlowRate(profileContext[1])

        profileContext[2] = profile[3] // hv
        setHv(profileContext[2])

        profileContext[3] = profile[4] // lv
        setLv(profileContext[3])

        profileContext[4] = profile[5] // dutyCycle
        setDutyCycle(profileContext[4])

        profileContext[5] = profile[6] // frequency
        setFrequency(profileContext[5])

        // This is the setTabIndex state function to change the user view from Profile List to Sliders
        props.stateFunctions[0](1)
        profileContext[0] = ""
    }

    const handleCompareContextHelper = () => {
        compareContext[0] = profileContext[0]
        // stateFunctions[1] is setCompareProfileName
        props.stateFunctions[1](profileContext[0])

        compareContext[1] = profileContext[1]
        // stateFunctions[2] is setCompareFlowRate
        props.stateFunctions[2](profileContext[1])

        compareContext[2] = profileContext[2]
        // stateFunctions[3] is setCompareHv
        props.stateFunctions[3](profileContext[2])

        compareContext[3] = profileContext[3]
        // stateFunctions[4] is setCompareLv
        props.stateFunctions[4](profileContext[3])

        compareContext[4] = profileContext[4]
        // stateFunctions[5] is setCompareDutyCycle
        props.stateFunctions[5](profileContext[4])

        compareContext[5] = profileContext[5]
        // stateFunctions[6] is setCompareFrequency
        props.stateFunctions[6](profileContext[5])
    }

    const exportProfile = async (profile) => {
        setProfileId(profile[0])
        const token = localStorage.getItem("token")
        const response = await axios.post("http://18.234.199.102:5000/profiles/export", {"profileId":profile[0]}, 
        {
            responseType:"arraybuffer"
    })

        if (window.confirm(`Do you wish to export ${profile[1]}?`) === true) {
            const file = new Blob([response.data], {
            });

            const url = URL.createObjectURL(file);
            const link = document.createElement("a")
            link.download = `${profile[1]}.zip`
            link.href = url
            link.click()
            }
    }

    const showCurrentProfile = (profile) => {
        // This function sets the single profile context to represent the
        // profile click on by the user.

        if (props.stateFunctions[10] === true && profileContext[0] === profile[1]) {
            // accounts for if the eye icon is clicked on the same profile being currently viewed
            props.stateFunctions[11](false)
            profileContext[0] = "" // profileName
            setProfileName(profileContext[0])

            profileContext[1] = 0 // flowRate
            setFlowRate(profileContext[1])

            profileContext[2] = 0 // hv
            setHv(profileContext[2])

            profileContext[3] = 0 // lv
            setLv(profileContext[3])

            profileContext[4] = 0 // dutyCycle
            setDutyCycle(profileContext[4])

            profileContext[5] = 0 // frequency
            setFrequency(profileContext[5])

            return
        }
        // This is required to force the parent component to eventually rerender once new values are set
        if (props.stateFunctions[10] === true) {
            resetSetSingleProfileViewState(profile)
        }

        setProfileId(profile[0]) // profileId

        profileContext[0] = profile[1] // profileName
        setProfileName(profileContext[0])

        profileContext[1] = profile[2] // flowRate
        setFlowRate(profileContext[1])

        profileContext[2] = profile[3] // hv
        setHv(profileContext[2])

        profileContext[3] = profile[4] // lv
        setLv(profileContext[3])

        profileContext[4] = profile[5] // dutyCycle
        setDutyCycle(profileContext[4])

        profileContext[5] = profile[6] // frequency
        setFrequency(profileContext[5])

        // This is the setSingleProfileView state function
        // This sets our flag to show this profiles values to true and changes the graph to reflect this
        props.stateFunctions[11](true)
      }

      const resetSetSingleProfileViewState = (profile) => {
        props.stateFunctions[11](false)
        // This state function sets the profile name that we are currently viewing, it is needed to force the parent
        // component to rerender and display the upcoming values
        props.stateFunctions[12](profile[1])
        return
      }


    useEffect(() => {
        const username = localStorage.getItem("username")
        const payload = {"username": username}
        try {
            const profileData = fetchProfiles(payload)
        } catch (error) {
            console.log(error)
        }

    }, [])

    return (
        <>
        <div className="profile__display__header">Profiles</div>
        <div className="profile__list">
            <div className="profile__list__actions">Actions</div>
            <div className="profile__list__profile-names">Profile Name</div>
            <div className="profile__list__compare">Compare</div>
        </div>
        <div className="profile__display">
        {profiles.length === 0 ?
                <div className="loading__logo">
                    <img src={logo} className="app__logo" alt="logo" />
                </div>
            : ( 
                <div>
                    {profiles.map(profile => 
                        <div className="single__profile" key={profile[0] + "singleProfileDiv"}>
                            <div className="profile__list__actions__group">
                                <FontAwesomeIcon title="Copy Profile" className="single__profile__icon" key={profile[0] + "Copy"} onClick={() => {cloneProfile(profile)}} icon={faCopy} />
                                <FontAwesomeIcon title="Download Profile" className="single__profile__icon" key={profile[0] + "File"} onClick={() => {exportProfile(profile)}} icon={faFileDownload} />
                                <FontAwesomeIcon title="View Profile" className={props.stateFunctions[8].length !== 0 ? "single__profile__icon__disabled" :"single__profile__icon"} icon={faEye} onClick={() => {showCurrentProfile(profile)}}/>
                            </div>
                            <div className={props.stateFunctions[8].includes(profile[1]) ? "single__profile__name__highlighted" : "single__profile__name"} key={profile[0]}>{profile[1]}</div>
                            <div className="single__profile__compare">
                                <input title="Select To Compare" type="checkbox" className="single__profile__input" id={profile[0]} key={profile[0] + "Input"} checked={props.stateFunctions[8].includes(profile[1]) ? true : false} onChange={() => {props.stateFunctions[7](profile)}}></input>
                            </div>
                        </div>

                            )}
                </div>)}
        </div>
        {/* <div className="borderBoxProfiles">
            <div className="profileDisplay">
                {profiles.length === 0 ?
                <div className="loadingLogo">
                    <img src={logo} className="App-logo" alt="logo" />
                </div>
            : (
                <div>
                    <div>
                        {profiles.map(profile => 
                        <div className="singleProfile" key={profile[0] + "singleProfileDiv"}>
                            <div className="profileIconsDiv" key={profile[0] + "profileIconsDiv"}>
                                <input title="Select To Compare" type="checkbox" className="profileInputBox" id={profile[0]} key={profile[0] + "Input"} checked={props.stateFunctions[8].includes(profile[1]) ? true : false} onClick={() => {props.stateFunctions[7](profile)}}></input>
                                <FontAwesomeIcon title="Copy Profile" className="copyIcon" key={profile[0] + "Copy"} onClick={() => {cloneProfile(profile)}} icon={faCopy} />
                                <FontAwesomeIcon title="Download Profile" className="fileDownloadIcon" key={profile[0] + "File"} onClick={() => {exportProfile(profile)}} icon={faFileDownload} />
                                <FontAwesomeIcon title="View Profile" className="eyeIcon" icon={faEye} onClick={() => {showCurrentProfile(profile)}}/>
                            </div>
                            <div className="textCenter">
                                <h4 className="profileName" key={profile[0]}>{profile[1]}</h4>
                            </div>
                        </div>

                            )}
                    </div>
                </div>
            )}

            </div>
        </div> */}
        </>
    )
}

export default ProfileListComponent